import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const ACILIYET_RENK: Record<string, string> = { 'Dusuk': '#94a3b8', 'Orta': '#ff9500', 'Yuksek': '#ff4444', 'Acil Durum': '#ff0033' };
const DURUM_RENK: Record<string, string> = { 'Bekliyor': '#94a3b8', 'Inceleniyor': '#4488ff', 'Onariliyor': '#ff9500', 'Tamamlandi': '#52c41a' };
const DURUM_ILERLEME: Record<string, number> = { 'Bekliyor': 10, 'Inceleniyor': 35, 'Onariliyor': 65, 'Tamamlandi': 100 };
const ACIKLAMA_UZUNLUK: number = 100; // 100 karakter üzeri "uzun" say

@Component({
  selector: 'bakim-talebi-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui text-center fluid pb-2">
      <div class="ui primary label mini"> Bakım Tanımı </div>
    </div>
    <div class="sk" [style.--sk-accent]="aciliyetRenk()">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('makine') || 'Bilinmeyen Makine' }}</div>
        @if (deger('arizaTuru')) { <div class="sk-alt">{{ deger('arizaTuru') }}</div> }
    
          <div class="sk-alt"(click)="toggleDesc()" [class.expanded]="aciklamaAcik()">
            {{ aciklamaAcik() ? p()?.aciklama : (p()?.aciklama | slice:0:100) + '...' }}
          </div>
        @if (aciklamaUzun()) {
          <div class="sk-alt" style="max-width:220px; color:#007bff; cursor:pointer;" (click)="toggleDesc()">
            {{ aciklamaAcik() ? 'Kapat' : 'Devam' }}
          </div>
        }
        <div style="display:flex;align-items:center;gap:6px;margin-top:2px">
          @if (deger('durum')) { <span class="sk-chip" [style.border-color]="durumRenk()">{{ deger('durum') }}</span> }
          @if (deger('raporEden')) { <span class="sk-alt">{{ deger('raporEden') }}</span> }
        </div>
        <div class="sk-bar"><div class="sk-bar-dolgu" [style.width.%]="ilerleme()" [style.background]="aciliyetRenk()"></div></div>
      </div>
      <div class="sk-sag">
        @if (deger('aciliyet')) { <span class="sk-badge" [style.background]="aciliyetRenk()">{{ deger('aciliyet') }}</span> }
      </div>
    </div>
  `,
})
export class BakimTalebiKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); };
  p = computed(() => this.parametreler()?.ek || {});
  expanded = signal(false);
  aciklamaAcik = signal(false);
  toggleDesc() { this.aciklamaAcik.update(v => !v); }
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  aciliyetRenk = computed(() => ACILIYET_RENK[this.deger('aciliyet')] || '#94a3b8');
  durumRenk = computed(() => DURUM_RENK[this.deger('durum')] || '#94a3b8');
  ilerleme = computed(() => DURUM_ILERLEME[this.deger('durum')] || 10);
  aciklamaUzun = computed(() => {
    const txt = this.deger("aciklama");
    return txt && typeof txt === 'string' && txt.length > ACIKLAMA_UZUNLUK;
  });
}
